// import Header from '../../components/Header/Header';
import Menu from '../../components/Menu/Menu';
import './Home.scss';
export default function Home() {
    return (
        <div id="home">
            <div className='centered-container'>
                <Menu title="Ratonera" options={[
                    // { name: 'Minigames', path: '/misc/minigames' },
                    { name: 'Lists', path: '/lists' },
                    // { name: 'Telegram', path: '/telegram' },
                    { name: 'Bingo Challenges', path: '/bingo/challenges' },
                    { name: 'Git', path: '/git' },
                    // { name: 'Misc', path: '/misc' },
                    // { name: 'Metrics', path: '/metrics' },
                    // { name: 'About', path: '/about' },
                ]} />
            </div>
        </div>
    );
}
// scp -P 4022 -r build david@rattonera.duckdns.org:/home/david/tmp